export { DescriptionClipper } from './DescriptionClipper';
